<template>
  <div>
    <div class="p-16">
      <div class="max-w-5xl mx-auto space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500">Facebook Campaigns</h4>
        </div>
        <FacebookCampaignListComponent
          v-bind="{ fetching, filterPresets, facebookCampaigns, meta }"
          @get-facebook-campaigns="handleGetCampaigns"
        />
      </div>
      <div>
        <Component
          :is="currentModal"
          :facebook-campaign-id="facebookCampaignId"
          @closed="handleCloseModal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { facebookCampaignComputed, facebookCampaignMethods } from '@/store/adminHelper';
import FacebookCampaignListComponent from '@/components/FacebookCampaigns/List.vue';
import DropdownList from '@/components/Ui/DropdownList.vue';
import DropdownListItem from '@/components/Ui/DropdownListItem.vue';

export default {
  name: 'CampaignList',
  components: {
    FacebookCampaignListComponent,
    DropdownList,
    DropdownListItem,
  },
  data: () => ({
    fetching: false,
    facebookCampaignId: null,
    editingType: null,
    currentModal: null,
    lastUsedQueryParams: null,
    filterPresets: [
      {
        name: 'all',
        query: {},
        default: true,
      },
      {
        name: 'active',
        query: { status: 'ACTIVE' },
        default: false,
      },
      {
        name: 'paused',
        query: { status: 'PAUSED' },
        default: false,
      },
      {
        name: 'withoutAccount',
        query: { has_channel: false },
        default: false,
      },
      {
        name: 'Χωρίς Ad Plan',
        query: { has_campaign: false },
        default: false,
      },
    ],
  }),
  computed: {
    ...facebookCampaignComputed,
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...facebookCampaignMethods,
    async handleGetCampaigns(queryParams = {}) {
      this.lastUsedQueryParams = JSON.parse(JSON.stringify(queryParams));
      this.fetching = true;
      try {
        await this.getFacebookCampaigns({
          queryParams: {
            ...queryParams,
            include: 'lifetimeReport',
          },
        });
      } catch (error) {
        //
      } finally {
        this.fetching = false;
      }
    },
    handleCreateOrUpdateChannel(facebookCampaign, next) {
      this.facebookCampaignId = facebookCampaign.id;
      this.editingType = 'facebook-campaigns';
      this.currentModal = 'ModalCreateOrUpdateChannel';
      next();
    },
    handleCloseModal() {
      this.currentModal = null;
      this.facebookCampaignId = null;
      this.editingType = null;
      this.handleGetCampaigns(this.lastUsedQueryParams);
    },
  },
};
</script>
